export enum HighwaysVersionState {
    IMPORTED,
    IN_PROGRESS,
    APPROVED,
    REPLACED,
    REJECTED,
    FAILED
  }
  
  export const HighwaysVersionStateMap = new Map<HighwaysVersionState, string>([
    [HighwaysVersionState.IMPORTED, "Imported"],
    [HighwaysVersionState.IN_PROGRESS, "In Progress"],
    [HighwaysVersionState.APPROVED, "Approved"],
    [HighwaysVersionState.REPLACED, "Replaced"],
    [HighwaysVersionState.REJECTED, "Rejected"],
    [HighwaysVersionState.FAILED, "Failed"]
  ]);